// Module replacement for @apollo/client
export { useQuery, useLazyQuery, useMutation } from '@atlassian/ufo-integrations-apollo-client';

export {
  useReactiveVar,
  getApolloContext,
  resetApolloContext,
  ApolloProvider,
  ApolloConsumer,
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  gql,
  ApolloError,
  ApolloCache,
  useApolloClient,
  Observable,
  isReference,
  makeReference,
  MissingFieldError,
  defaultDataIdFromObject,
  makeVar,
  isApolloError,
  fromError,
  fromPromise,
  toPromise,
  disableExperimentalFragmentVariables,
  disableFragmentWarnings,
  enableExperimentalFragmentVariables,
  resetCaches,
  ObservableQuery,
  concat,
  empty,
  execute,
  from,
  split,
  checkFetcher,
  createHttpLink,
  createSignalIfSupported,
  fallbackHttpConfig,
  parseAndCheckHttpResponse,
  rewriteURIForGET,
  selectHttpOptionsAndBody,
  selectURI,
  serializeFetchParameter,
  operationName,
  parser,
  throwServerError,
  NetworkStatus,
  Cache,
  DocumentType,
  mergeOptions,
  setLogVerbosity,
  isNetworkRequestSettled,
  defaultPrinter,
  selectHttpOptionsAndBodyInternal,
  skipToken,
  useBackgroundQuery,
  useFragment,
  useReadQuery,
  useSuspenseQuery,
  DocumentTransform,
  useSubscription,
} from '@apollo/client';

export type {
  ApolloContextValue,
  OperationVariables,
  Context,
  BaseQueryOptions,
  QueryFunctionOptions,
  ObservableQueryFields,
  QueryResult,
  RefetchQueriesFunction,
  BaseMutationOptions,
  MutationFunctionOptions,
  MutationResult,
  MutationFunction,
  OnSubscriptionDataOptions,
  BaseSubscriptionOptions,
  SubscriptionResult,
  CommonOptions,
  QueryOptions,
  QueryHookOptions,
  MutationHookOptions,
  MutationOptions,
  MutationTuple,
  SubscriptionHookOptions,
  SubscriptionOptions,
  SubscriptionCurrentObservable,
  InMemoryCacheConfig,
  DocumentNode,
  FetchResult,
  MutationDataOptions,
  MutationQueryReducer,
  MutationQueryReducersMap,
  DefaultOptions,
  Reference,
  QueryListener,
  ReadMergeModifyContext,
} from '@apollo/client';
